import { Form, FormProps } from "@/components/form";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { localNow } from "@/shared/local-now";
import { TransferenciaItemRequest } from "@/shared/types/transferencia";
import { Stack, Typography } from "@mui/material";
import { z } from "zod/v4";

export const addCajaMovimientoFormSchema = z.object({
    fecha: z.iso.datetime({ local: true, message: "Este campo es requerido" }).default(localNow()),
    descripcion: z.string(),
    transferencia: z.object({
        items: z.array(z.object({
            monto: z.object({
                items: z.array(z.object({
                    monedaId: z.string().nonempty("Requerido"),
                    cantidad: z.number({ message: "Requerido" })
                }))
            }),
            transferenciaMetodoId: z.string().nonempty("Este campo es requerido")
        })).transform(v => v.filter(vi => vi.monto).map(vi => vi as TransferenciaItemRequest))
    }).refine(v => v.items.length > 0, { message: "El monto total no puede ser 0." })
})

export default function AddCajaMovimientoForm({
    form,
    ...props
}: FormProps<z.input<typeof addCajaMovimientoFormSchema>>) {
    const { transferenciaMetodos } = useMonetizacion();

    return <Form form={form} gap={3} {...props}>
        <Typography variant="h6">Datos Generales</Typography>
        <Form.DatePicker name="fecha" label="Fecha" />
        <Form.TextField name="descripcion" label="Descripción" rows={3} multiline />
        <Stack gap={3}>
            <Typography variant="h6" position={"relative"}>Montos</Typography>
            <form.Field name="transferencia.items" mode="array">
                {field => field.state.value.map((ti, index) => {
                    const metodo = transferenciaMetodos.find(tm => tm.id === ti.transferenciaMetodoId);
                    if (!metodo) return;

                    return <Form.MontoField
                        key={metodo.id}
                        name={`transferencia.items[${index}].monto`}
                        label={metodo.nombre}
                        allowNegative
                    />
                })}
            </form.Field>
        </Stack>
        <Form.SubmitButton>
            Guardar
            <Form.ErrorText name="transferencia" />
        </Form.SubmitButton>
    </Form>
}